import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

const DashboardHeader = () => {
  const { t } = useTranslation();
  const [user, setUser] = useState({ name: '', companyName: '' });

  useEffect(() => {
    async function fetchUser() {
      try {
        const BASE = process.env.REACT_APP_API_URL || "";
        const res = await fetch(`${BASE}/auth/me`, {
          credentials: 'include'
        });
        if (res.ok) {
          const json = await res.json();
          if (json.ok && json.user) {
            setUser({
              name: json.user.name || 'User',
              companyName: json.user.companyName || ''
            });
          }
        }
      } catch (err) {
        console.error("Failed to fetch user:", err);
      }
    }
    fetchUser();
  }, []);

  const displayName = user.name || 'User';
  const avatarName = encodeURIComponent(displayName);

  return (
    <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between pb-4 sm:pb-6 gap-3 sm:gap-4" data-tour="dashboard-header">
      <div className="flex items-center gap-3 sm:gap-4">
        <img src="/logo.png" alt="Pro IRP Logo" className="w-10 h-10 sm:w-12 sm:h-12 rounded-full bg-white shadow" />
        <div>
          <div className="text-xl sm:text-2xl font-extrabold text-[#172A3A] tracking-tight">
            {t('dashboard')}
          </div>
          <div className="text-xs sm:text-sm text-[#20344A] font-medium">
            {t('welcomeBack')}
          </div>
        </div>
      </div>
      <div className="flex items-center gap-3 sm:gap-4 self-end sm:self-auto">
        <div className="text-right">
          <div className="font-semibold text-[#172A3A] text-sm sm:text-base">{displayName}</div>
          {user.companyName && (
            <div className="text-xs text-[#20344A]">{user.companyName}</div>
          )}
        </div>
        <img
          src={`https://ui-avatars.com/api/?name=${avatarName}&background=172A3A&color=fff&size=48`}
          alt="User"
          className="w-9 h-9 sm:w-10 sm:h-10 rounded-full"
        />
      </div>
    </div>
  );
};

export default DashboardHeader;
